import { Component, Input, Output, forwardRef, OnInit, EventEmitter, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { StateService, AuthService, CustomerService, ScriptService, SquareService } from '../../services';
import { Authenticate, CustomerRegistrationRequestModel } from '../../models';
import { FormFunctions } from '../../functions';
import { RecaptchaComponent } from 'ng-recaptcha';

declare global {
    interface Window {
        Square: any;
        test: any;
    }
}

@Component({
    selector: 'customer-registration',
    templateUrl: './customer-registration.component.html'
})
export class CustomerRegistrationComponent implements OnInit {
    card = null;

    @ViewChild("recaptcha") recaptcha: RecaptchaComponent;
    processing: boolean = false;
    error: string = "";
    request: CustomerRegistrationRequestModel;
    shippingAddressSameAsBilling: boolean = true;
    states: any[] = [
        { value: 'ACT', label: 'ACT' },
        { value: 'NSW', label: 'NSW' },
        { value: 'NT', label: 'NT' },
        { value: 'QLD', label: 'QLD' },
        { value: 'SA', label: 'SA' },
        { value: 'TAS', label: 'TAS' },
        { value: 'VIC', label: 'VIC' },
        { value: 'WA', label: 'WA' },
        // 'ACT',
        // 'NSW',
        // 'NT',
        // 'QLD',
        // 'SA',
        // 'TAS',
        // 'VIC',
        // 'WA',
    ];
    @Input() successRedirect: string = '/account';
    @Output() onSuccess: EventEmitter<any> = new EventEmitter();

    constructor(public router: Router,
        private renderer: Renderer2,
        private scriptService: ScriptService,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        public authService: AuthService,
        public customerService: CustomerService,
        public formFunctions: FormFunctions,
        private squareService: SquareService,
    ) {
        let me = this;
        me.request = new CustomerRegistrationRequestModel();

        // START TEST DATA
        window.test = () => {
            me.request.Email = 'wes.cogan+4@websilk.com.au';
            me.request.Password = 'Password12345';
            me.request.FirstName = 'Wes';
            me.request.LastName = 'Cogan';
            me.request.Phone = '03 9600 1234';
            me.request.AddressLine1 = 'Level 3/971 Burke Rd';
            me.request.AddressLine2 = '';
            me.request.Suburb = 'Camberwell';
            me.request.Postcode = '3124';
            me.request.State = 'VIC';
            me.request.CaptchaToken = 'TEST';
            this.updateShippingAddressMatch();
        };
        // END TEST DATA

        me.request.Country = 'Australia';

        this.updateShippingAddressMatch();
    }

    updateShippingAddressMatch() {
        if (this.shippingAddressSameAsBilling === true) {
            this.request.ShippingAddressLine1 = this.request.AddressLine1;
            this.request.ShippingAddressLine2 = this.request.AddressLine2;
            this.request.ShippingSuburb = this.request.Suburb;
            this.request.ShippingState = this.request.State;
            this.request.ShippingPostcode = this.request.Postcode;
            this.request.ShippingCountry = this.request.Country;
        } else {
            this.request.ShippingAddressLine1 = "";
            this.request.ShippingAddressLine2 = "";
            this.request.ShippingSuburb = "";
            this.request.ShippingState = "";
            this.request.ShippingPostcode = "";
            this.request.ShippingCountry = "";
        }
    }

    ngOnInit() {
        let me = this;

        me.processing = true;
        me.squareService.getSettings().subscribe(data => {
            // console.log('getSettings', data);
            me.loadSquareJs(data.ApplicationId, data.LocationId, data.Production ? 'https://web.squarecdn.com/v1/square.js' : 'https://sandbox.web.squarecdn.com/v1/square.js')
        });
    }

    loadSquareJs(appId, locationId, squareJsUrl) {
        let me = this;
        const scriptElement = this.scriptService.loadJsScript(this.renderer, squareJsUrl);
        scriptElement.onload = async () => {
            if (!window.Square) {
                throw new Error('Square.js failed to load properly');
            }
            const payments = window.Square.payments(appId, locationId);
            try {
                this.card = await me.initializeCard(payments);
                this.processing = false;
            } catch (e) {
                console.error('Initializing Card failed', e);
                return;
            }
        };
        scriptElement.onerror = () => {
            //   console.log('Could not load the Square API Script!');
        };
    }

    async initializeCard(payments) {
        const card = await payments.card();
        await card.attach('#card-container');
        return card;
    }

    // This function tokenizes a payment method. 
    // The ‘error’ thrown from this async function denotes a failed tokenization,
    // which is due to buyer error (such as an expired card). It is up to the
    // developer to handle the error and provide the buyer the chance to fix
    // their mistakes.
    async tokenize(paymentMethod) {
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === 'OK') {
            return tokenResult.token;
        } else {
            let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
            if (tokenResult.errors) {
                errorMessage += ` and errors: ${JSON.stringify(
                    tokenResult.errors
                )}`;
            }
            throw new Error(errorMessage);
        }
    }

    async handlePaymentMethodSubmission(paymentMethod) {
        //event.preventDefault();

        try {
            // disable the submit button as we await tokenization and make a
            // payment request.
            this.processing = true;
            const token = await this.tokenize(paymentMethod);
            this.request.PaymentToken = token;
            //const paymentResults = await this.createPayment(token);
            if (this.error) this.error = '';
            this.processing = false;

            //console.debug('Payment Success', paymentResults);
        } catch (e) {
            this.error = 'Tokenization failed';
            console.error(e.message);
        }
        this.processing = false;
    }

    async Register(form, e) {
        let me = this;
        me.error = "";

        if (me.formFunctions.isFormValid(form, e)) {
            await this.handlePaymentMethodSubmission(this.card);
            me.processing = true;
            me.customerService.register(me.request).subscribe(data => {
                if (data && data.Success) {
                    me.stateService.changeUserModel(data.User);
                    if (me.successRedirect != '') {
                        me.router.navigate([me.successRedirect]);
                    } else {
                        me.onSuccess.emit(data.User.Id);
                    }
                } else {
                    this.recaptcha.reset();
                    if (data?.Message) me.error = data?.Message;
                }
                me.processing = false;

            }, err => {
                me.processing = false;
                me.error = "Something went wrong. Please try again"

                if (err.status != 401) {
                    this.recaptcha.reset();
                    if (err?.error?.Message) me.error = err?.error?.Message;
                }
            });
        } else {
            me.error = "Please complete all fields.";
        }
    }
}



